import { arrayOf, number, oneOfType, shape, string } from 'prop-types';

const sourcesShape = {
  name: string,
  agencyname: string,
  url: string
};

export type sourcesShapeTypescript = {
  name?: string;
  agencyname?: string;
  url?: string;
};

const dataShape = {
  x_type: string,
  y_type: string,
  name: string.isRequired,
  id: oneOfType([string, number]).isRequired,
  sources: arrayOf(shape(sourcesShape)),
  footnote: string,
  meta: arrayOf(
    shape({
      data: string,
      type: string
    })
  ),
  data: arrayOf(
    shape({
      key: string.isRequired,
      value: number // Not required since we allow nulls
    })
  ).isRequired
};

export type dataShapeTypescript = {
  // eslint-disable-next-line camelcase
  x_type?: string;
  // eslint-disable-next-line camelcase
  y_type?: string;
  name: string;
  id: string | number;
  sources?: sourcesShapeTypescript[];
  footnote?: string;
  meta?: {
    data?: string;
    type?: string;
  }[];
  data: {
    key: string;
    // Not required since we allow nulls
    value?: number;
  }[];
};

export { dataShape, sourcesShape };
